// function* MeasurementIdGenerator() {
//   let count = 1;
//   while (true) {
//     yield count++;
//   }
// }

// export const generateMeasurmentId = MeasurementIdGenerator();

function* MeasurementPreviewIdGenerator() {
  let count = 1;
  while (true) {
    yield count++;
  }
}
export const generatePreviewMeasurmentId = MeasurementPreviewIdGenerator();


export function getRoundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number
) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
}
